import { render, staticRenderFns } from "./Recu.vue?vue&type=template&id=778f4a51&scoped=true&"
import script from "./Recu.vue?vue&type=script&lang=js&"
export * from "./Recu.vue?vue&type=script&lang=js&"
import style0 from "./Recu.vue?vue&type=style&index=0&id=778f4a51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f4a51",
  null
  
)

export default component.exports